import talentsData from "../data/talents.json"
import { getEffective } from "./applyHomebrew"
import getInnateTalents from "./GetInnateTalents"

function getFullBoughtTalents(character, { includeGear = true } = {}) {
  const talents = getEffective('talents', talentsData);
  let universalForce = 0;
  let Bought = [];
  const talentMap = {};
  let talentData = {};
  if (character.Extras?.BattleScars && character.Extras.BattleScars[0]) {
    for (let m in character.Extras.BattleScars) {
      talentData = talents.find(
        (t) => t.Key === character.Extras.BattleScars[m].key,
      );
      talentMap[character.Extras.BattleScars[m].key] = talentData;
      Bought.push({
        key: character.Extras.BattleScars[m].key,
        data: talentMap[character.Extras.BattleScars[m].key],
        count: 1,
      });
    }
  }
  if (character.Species.TalentModifiers) {
    if (character.Species.TalentModifiers[0]) {
      for (let m in character.Species.TalentModifiers) {
        talentData = talents.find(
          (t) => t.Key === character.Species.TalentModifiers[m].Key,
        );
        talentMap[character.Species.TalentModifiers[m].Key] = talentData;
        Bought.push({
          key: character.Species.TalentModifiers[m].Key,
          data: talentMap[character.Species.TalentModifiers[m].Key],
          count: 1,
        });
      }
    } else if (character.Species.TalentModifiers.Key) {
      talentData = talents.find(
        (t) => t.Key === character.Species.TalentModifiers.Key,
      );
      talentMap[character.Species.TalentModifiers.Key] = talentData;
      Bought.push({
        key: character.Species.TalentModifiers.Key,
        data: talentMap[character.Species.TalentModifiers.Key],
        count: 1,
      });
    }
  }
  if (character.Species.OptionChoices && Array.isArray(character.Species.OptionChoices)) {
    character.Species.OptionChoices.forEach(optionChoice => {
      if (optionChoice.Options && Array.isArray(optionChoice.Options) && optionChoice.Selected) {
        // Support both checklist (array Selected) and single-select (string Selected)
        const selectedKeys = Array.isArray(optionChoice.Selected) ? optionChoice.Selected : [optionChoice.Selected];
        selectedKeys.forEach(key => {
          const selectedOpt = optionChoice.Options.find(o => o.Key === key);
          if (selectedOpt?.TalentModifiers) {
            const mods = Array.isArray(selectedOpt.TalentModifiers) ? selectedOpt.TalentModifiers : [selectedOpt.TalentModifiers];
            mods.forEach(mod => {
              if (mod.Key) {
                const td = talents.find(t => t.Key === mod.Key);
                if (td) {
                  const existing = Bought.find(b => b.key === mod.Key);
                  if (existing) existing.count++;
                  else Bought.push({ key: mod.Key, data: td, count: 1 });
                }
              }
            });
          }
        });
      }
    });
  }
  if (
    character.Species.SubSpeciesList &&
    character.Species.SubSpeciesList.find(
      (ss) => (ss.Key === character.Species.SubSpecies),
    ) &&
    character.Species.SubSpeciesList.find(
      (ss) => (ss.Key === character.Species.SubSpecies),
    ).TalentModifiers
  ) {
    if (
      character.Species.SubSpeciesList.find(
        (ss) => (ss.Key === character.Species.SubSpecies),
      ).TalentModifiers[0]
    ) {
      for (let m in character.Species.SubSpeciesList[
        character.Species.SubSpecies
      ].TalentModifiers) {
        talentData = talents.find(
          (t) =>
            t.Key ===
            character.Species.SubSpeciesList.find(
              (ss) => (ss.Key === character.Species.SubSpecies),
            ).TalentModifiers[m].Key,
        );
        talentMap[
          character.Species.SubSpeciesList[
            character.Species.SubSpecies
          ].TalentModifiers[m].Key
        ] = talentData;
        Bought.push({
          key: character.Species.SubSpeciesList.find(
            (ss) => (ss.Key === character.Species.SubSpecies),
          ).TalentModifiers[m].Key,
          data: talentMap[
            character.Species.SubSpeciesList.find(
              (ss) => (ss.Key === character.Species.SubSpecies),
            ).TalentModifiers[m].Key
          ],
          count: 1,
        });
      }
    } else if (
      character.Species.SubSpeciesList.find(
        (ss) => (ss.Key === character.Species.SubSpecies),
      ).TalentModifiers.Key
    ) {
      talentData = talents.find(
        (t) =>
          t.Key ===
          character.Species.SubSpeciesList.find(
            (ss) => (ss.Key === character.Species.SubSpecies),
          ).TalentModifiers.Key,
      );
      talentMap[
        character.Species.SubSpeciesList.find(
          (ss) => (ss.Key === character.Species.SubSpecies),
        ).TalentModifiers.Key
      ] = talentData;
      Bought.push({
        key: character.Species.SubSpeciesList.find(
          (ss) => (ss.Key === character.Species.SubSpecies),
        ).TalentModifiers.Key,
        data: talentMap[
          character.Species.SubSpeciesList.find(
            (ss) => (ss.Key === character.Species.SubSpecies),
          ).TalentModifiers.Key
        ],
        count: 1,
      });
    }
  }
  for (let i in character.Specializations) {
    if (
      character.Specializations[i].Attributes &&
      character.Specializations[i].Attributes.ForceRating
    ) {
      universalForce = 1;
    }
    let specialization = character.Specializations[i];
    if (specialization.TalentRows) {
      specialization.TalentRows.forEach((row, rowIndex) => {
        row.Talents.forEach((talentKey, index) => {
          if (specialization.BoughtTalents[rowIndex][index]) {
            if (!talentMap[talentKey]) {
              const talentData = talents.find((t) => t.Key === talentKey);
              if (!talentData) return;
              talentMap[talentKey] = talentData;
            }
            const existingTalent = Bought.find((t) => t.key === talentKey);
            if (existingTalent) {
              existingTalent.count++;
            } else {
              Bought.push({
                key: talentKey,
                data: talentMap[talentKey],
                count: 1,
              });
            }
          }
        });
      });
    }
  }
  const Innate = getInnateTalents(character);
  if (includeGear) {
    Innate.forEach((innate) => {
      const existing = Bought.find((t) => t.key === innate.key);
      if (existing) {
        existing.count += innate.count;
        existing.innate = (existing.innate || 0) + innate.count;
      } else {
        Bought.push({ key: innate.key, data: innate.data, count: innate.count, innate: innate.count });
      }
    });
  }
  Bought.forEach((t) => {
    if (String(t.data?.Ranked) !== "true" && t.count > 1) {
      t.count = 1;
      if (t.innate) { t.innate = 1; }
    }
  });
  return { Bought, universalForce, Innate };
}

export default getFullBoughtTalents